import type { ReactNode } from 'react';
import { Heading } from '@heroui/react';

interface UsageHistorySectionProps {
  title: string;
  count: number;
  children: ReactNode;
}

export function UsageHistorySection({ title, count, children }: UsageHistorySectionProps) {
  if (count === 0) return null;

  return (
    <section className="flex flex-col gap-3">
      <Heading level={3} className="text-base font-semibold">
        {title} ({count})
      </Heading>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">{children}</div>
    </section>
  );
}
